import { createApp } from 'vue'
import App from './App.vue'
import store from './store';
import { create, NButton, NSwitch } from 'naive-ui'; // Importa i componenti necessari





const naive = create({
  components: [NButton, NSwitch], // Aggiungi qui i componenti che usi
});

const app = createApp(App);
app.use(store); // Applica lo store Vuex
app.use(naive);
app.mount('#plp-app');
